import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DirtyInvalidErrorStateMatcher, FormControlsOf } from '@examdojo/angular/forms';
import { DatepickerToggleDirective } from '@examdojo/core/dialog';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'dojo-assessment-basic',
  templateUrl: './assessment-basic.component.html',
  styleUrls: ['./assessment-basic.component.scss'],
  imports: [
    MatFormFieldModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    TranslocoPipe,
    MatSlideToggleModule,
    DatepickerToggleDirective,
  ],
  providers: [provideNativeDateAdapter()],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssessmentBasicComponent {
  @Input({ required: true }) assessmentBasicForm!: FormGroup<
    FormControlsOf<{ name: string; date: Date | null; isActive: boolean }>
  >;

  readonly DirtyInvalidErrorStateMatcher = new DirtyInvalidErrorStateMatcher();
}
